import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { CheckCircle, ExternalLink } from 'lucide-react'
import Header from '../components/Header'
import { useAuth } from '../contexts/AuthContext'
import { api } from '../services/api'
import toast from 'react-hot-toast'

const SuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const { user } = useAuth()
  const [loading, setLoading] = useState(true)
  const [libreChatToken, setLibreChatToken] = useState<string | null>(null)
  const [libreChatUrl, setLibreChatUrl] = useState<string>('')

  const sessionId = searchParams.get('session_id')

  useEffect(() => {
    const handleSuccess = async () => {
      if (!sessionId) {
        toast.error('No session ID found')
        setLoading(false)
        return
      }

      try {
        // Here you would typically verify the session with Stripe
        // and update the user's subscription status
        
        // For now, we'll just fetch the LibreChat token
        if (user?.is_active) {
          const response = await api.get('/librechat/token')
          setLibreChatToken(response.data.token)
          setLibreChatUrl(response.data.librechat_url)
        }
        
        toast.success('Payment successful! Welcome to LibreChat!')
      } catch (error) {
        toast.error('Failed to process payment')
      } finally {
        setLoading(false)
      }
    }

    handleSuccess()
  }, [sessionId, user])

  if (loading) {
    return (
      <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #1f2937 0%, #111827 50%, #0f172a 100%)'}}>
        <Header />
        <div className="flex items-center justify-center min-h-96">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2" style={{borderColor: '#3A9E5A'}}></div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #1f2937 0%, #111827 50%, #0f172a 100%)'}}>
      <Header />
      
      <main className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full text-center">
          <div className="mb-8">
            <CheckCircle className="h-16 w-16 mx-auto mb-4" style={{color: '#3A9E5A'}} />
            <h1 className="text-3xl font-bold mb-2" style={{color: '#f9fafb'}}>
              Payment Successful!
            </h1>
            <p style={{color: '#d1d5db'}}>
              Your subscription has been activated. You now have full access to Inland Fiber AI.
            </p>
          </div>

          <div className="space-y-4">
            {libreChatToken && (
              <a
                href={`${libreChatUrl}?token=${libreChatToken}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary w-full"
              >
                Open Inland Fiber AI
                <ExternalLink className="ml-2 h-5 w-5" />
              </a>
            )}
            
            <Link
              to="/dashboard"
              className="btn btn-outline w-full"
            >
              Go to Dashboard
            </Link>
          </div>

          <div className="mt-8 text-sm" style={{color: '#9ca3af'}}>
            <p>
              You can manage your subscription and access Inland Fiber AI anytime from your dashboard.
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}

export default SuccessPage
